<template>
  <aside class="sidebar">
    <div class="brand" @click="$router.push('/dashboard')">
      <div class="brand-icon">
        <img src="/slices/logo@2x.png" alt="" />
      </div>
      <span class="brand-text">CrypPay</span>
    </div>

    <el-menu
      :default-active="active"
      class="side-menu"
      background-color="transparent"
      text-color="#8b92a8"
      active-text-color="#ffffff"
      router
    >
      <el-menu-item v-for="item in navItems" :key="item.path" :index="item.path">
        <img class="menu-icon-img" :src="menuIconSrc(item.num, item.path)" alt="" />
        <span slot="title">{{ item.label }}</span>
      </el-menu-item>
    </el-menu>

    <div class="sidebar-footer">
      <button type="button" class="logout-btn" @click="logout">
        <i class="el-icon-switch-button" />
        退出登录
      </button>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'AdminSidebar',
  data() {
    return {
      navItems: [
        { path: '/dashboard', label: '账户总览', num: 1 },
        { path: '/orders', label: '订单管理', num: 2 },
        { path: '/withdraw', label: '提现审核', num: 3 },
        { path: '/withdraw-fees', label: '提现手续费', num: 4 },
        { path: '/merchants', label: '商户管理', num: 5 }
      ]
    }
  },
  computed: {
    active() {
      const p = this.$route.path
      if (p.startsWith('/merchants')) return '/merchants'
      if (p.startsWith('/withdraw-fees')) return '/withdraw-fees'
      return p
    }
  },
  methods: {
    menuIconSrc(num, path) {
      const file = this.active === path ? `menu${num}_choose.png` : `menu${num}.png`
      return `${process.env.BASE_URL}slices/${file}`
    },
    logout() {
      sessionStorage.removeItem('cryptopay_admin_token')
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  width: 220px;
  min-height: 100vh;
  background: #171b32;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-right: none;
  flex-shrink: 0;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 20px 28px;
  cursor: pointer;
  flex-shrink: 0;
}

.brand-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  overflow: hidden;
  background: linear-gradient(135deg, #5b45ff, #a855f7);
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }
}

.brand-text {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.02em;
}

.side-menu {
  flex: 1;
  border-right: none !important;
  padding: 0 0 16px;
  overflow-y: auto;

  ::v-deep .el-menu-item {
    height: 48px;
    line-height: 48px;
    margin: 0 10px 2px;
    padding: 0 14px 0 16px !important;
    border-radius: 0;
    border-left: 3px solid transparent;
    display: flex;
    align-items: center;

    .menu-icon-img {
      width: 22px;
      height: 22px;
      object-fit: contain;
      flex-shrink: 0;
      margin-right: 12px;
    }

    &:hover {
      background: rgba(124, 58, 237, 0.1) !important;
      color: #e2e8f0 !important;
    }

    &.is-active {
      background: linear-gradient(90deg, rgba(168, 85, 247, 0.32), rgba(168, 85, 247, 0.02) 72%, transparent 100%) !important;
      border-left-color: #a855f7;
      color: #fff !important;
    }
  }
}

.sidebar-footer {
  padding: 16px 20px 24px;
  flex-shrink: 0;
}

.logout-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #8b92a8;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.2s, background 0.2s;

  i {
    font-size: 18px;
  }

  &:hover {
    color: #e2e8f0;
    background: rgba(255, 255, 255, 0.05);
  }
}
</style>
